<template>
  <v-card
    class="v-card--wizard"
    elevation="12"
    max-width="800"
  >
    <v-card-title class="justify-center display-2 font-weight-light pt-5">
      Configuração de Tabelas Personalizadas
    </v-card-title>

    <div class="text-center display-1 grey--text text--darken-1 font-weight-normal mb-6">
      Você poderá associar tabelas à contas e aos usuários
    </div>

    <v-tabs
      ref="tabs"
      v-model="internalValue"
      background-color="success"
      color="white"
      grow
      slider-size="72"
      class="white--text"
      icons-and-text
    >
      <v-tabs-slider
        class="mt-3 success darken-4"
      />

      <v-tab
        v-for="(item, i) in items"
        :key="i"
        :ripple="false"
        :disabled="!availableSteps.includes(i) || internalValue === items.length - 1 && !(internalValue === i)" 
        color="white"
        class="white--text d-inline-block pa-2 text-center"
      >
        <v-icon
          v-text="item.icon"
          large
          class="white--text"
        />
        {{ item.text }}
      </v-tab>
    </v-tabs>

    <div class="my-3" />

    <v-card-text>
      <v-tabs-items v-model="internalValue">
        <slot />
      </v-tabs-items>
    </v-card-text>

    <v-card-actions class="pb-4 pa-4">
      <v-btn
        v-if="!(internalValue === items.length - 1)"
        :disabled="internalValue === 0"
        class="white--text"
        color="primary"
        min-width="200"
        @click="$emit('click:prev')"
      >
        Anterior
      </v-btn>

      <v-spacer />

      <v-btn
        v-if="!(internalValue === items.length - 1)"
        :disabled="!availableSteps.includes(internalValue + 1)"
        color="success"
        min-width="200"
        @click="$emit('click:next')"
      >
        {{ internalValue === items.length - 2 ? 'Finalizar' : 'Próximo' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'

  export default {
    name: 'BaseMaterialWizard',

    mixins: [Proxyable],

    props: {
      availableSteps: {
        type: Array,
        default: () => ([]),
      },
      items: {
        type: Array,
        default: () => ([]),
      },
    },
  }
</script>

<style lang="sass">
  .v-card--wizard
    overflow: visible

    .v-tabs-bar
      height: 50px !important
      padding: 0 8px

    .v-tabs-slider-wrapper
      overflow: visible

    .v-tabs-slider
      border-radius: 4px

    .v-tabs-slider-wrapper
      contain: initial
      z-index: 0
</style>
